import dayjs from 'dayjs'

export function isTaskCompleted (task) {
  return !!(task.clientMarkedCompleted || task.isClosed)
}

export function getTaskStatus (task) {
  if (isTaskCompleted(task)) return 'completed'
  if (task.dueDate && dayjs(task.dueDate).isBefore(dayjs(), 'day')) return 'overdue'
  return 'outstanding'
}

export function formatTaskDate (isoDate) {
  if (!isoDate) return null
  return dayjs(isoDate).format('M/D/YYYY')
}

export function formatTaskDateLong (isoDate) {
  if (!isoDate) return null
  return dayjs(isoDate).format('ddd, MMM D, YYYY')
}

export function applyFilters (tasks, config) {
  let filtered = [...tasks]

  if (Array.isArray(config?.filterIds)) {
    const idSet = new Set(config.filterIds.map(String))
    filtered = filtered.filter(t => idSet.has(String(t.id)))
  }

  const completedFilter = config?.completedFilter ?? 'all'
  if (completedFilter === 'open') {
    filtered = filtered.filter(t => !isTaskCompleted(t))
  } else if (completedFilter === 'completed') {
    filtered = filtered.filter(t => isTaskCompleted(t))
  }

  filtered.sort((a, b) => {
    const da = a.dueDate ? dayjs(a.dueDate).valueOf() : Infinity
    const db = b.dueDate ? dayjs(b.dueDate).valueOf() : Infinity
    return da - db
  })

  const limit = config?.limit
  if (limit && limit > 0) {
    filtered = filtered.slice(0, limit)
  }

  return filtered
}
